module.exports = __webpack_public_path__ + "static/media/chat_bubble_outline.f21676b1.svg";